import { useEffect, useRef } from 'react';
import { isDemoMode } from '@/demo/demoState';

const CLARITY_PROJECT_ID = 'udc39bjhfm';

let clarityInitialized = false;

export const ClarityInit: React.FC = () => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current || clarityInitialized) return;
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    // Keep public demo traffic out of the app's Clarity project.
    if (isDemoMode()) return;

    initialized.current = true;
    clarityInitialized = true;

    // Standard Clarity snippet — sets window.clarity global, handles SPA navigation automatically
    (function (c: any, l: any, a: string, r: string, i: string, t?: any, y?: any) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', CLARITY_PROJECT_ID);
  }, []);

  return null;
};
